import { Pow18 } from 'config'
import { BigNumber } from 'ethers'
import { useMemo } from 'react'
import { OrderDirection } from 'store/spot/types'
import { Ether, Wei } from 'types'
import { bn, e2w } from 'utils/number'

export function calculateUnrealizedPnL(
  direction: OrderDirection,
  markPrice: BigNumber,
  multiplier: BigNumber,
  quantity: BigNumber,
  entryTotalValue: BigNumber,
): BigNumber {
  if (direction === OrderDirection.LONG) {
    return markPrice
      .mul(multiplier)
      .mul(quantity)
      .div(Pow18)
      .div(Pow18)
      .sub(entryTotalValue)
  } else if (direction === OrderDirection.SHORT) {
    return entryTotalValue.sub(
      markPrice.mul(multiplier).mul(quantity).div(Pow18).div(Pow18),
    )
  }
  return bn(0)
}

export function useUnrealizedPnL(
  direction: OrderDirection,
  markPrice: Ether,
  multiplier: number,
  quantity: number,
  entryTotalValue: number,
): Wei {
  return useMemo(() => {
    return calculateUnrealizedPnL(
      direction,
      e2w(markPrice),
      e2w(multiplier),
      e2w(quantity),
      e2w(entryTotalValue),
    ).toString()
  }, [direction, markPrice, multiplier, quantity, entryTotalValue])
}
